export default "__VITE_ASSET__D5iEuQBy__"